import { Box, Select, Space } from '@mantine/core';
import { FC, useContext, useEffect, useState } from 'react';
import { WindowContext } from '../../Service/Context/WindowContext';
import { EventS } from '../../Service/EventS';
import { EventKind } from '../../Types/EventT';
import { ThemeTitle } from '../../Atoms/ThemeText';

const StatisticsNavBar: FC<{
  year: string | null;
  setYear: (year: string | null) => void;
  eventKind: string | null;
  setEventKind: (eventKind: string | null) => void;
  leadOrigin: string | null;
  setLeadOrigin: (leadOrigin: string | null) => void;
}> = ({ year, setYear, eventKind, setEventKind, leadOrigin, setLeadOrigin }) => {
  const { sm } = useContext(WindowContext);
  const [eventKinds, setEventKinds] = useState<EventKind[]>();
  const existingKinds = eventKinds?.map((k) => k.name);
  const [leadOrigins, setLeadOrigins] = useState<string[]>();

  useEffect(() => {
    EventS.fetchEventKinds()
      .then(setEventKinds)
      .catch((error) => {
        console.error({ error });
        console.error(`could not load event kinds`);
      });

    EventS.fetchLeadOrigins()
      .then(setLeadOrigins)
      .catch((error) => {
        console.error({ error });
        console.error(`could not load lead origins`);
      });
  }, []);

  return (
    <>
      {!sm && (
        <ThemeTitle p="md" order={3}>
          Statistiken
        </ThemeTitle>
      )}
      <Box p="xs">
        <Select
          variant="filled"
          placeholder={'Jahr'}
          clearable={false}
          value={year}
          onChange={(val) => setYear(val)}
          mb="md"
          data={getYears()}
        />

        {existingKinds && (
          <Select
            variant="filled"
            value={eventKind}
            placeholder={'Auftragsart'}
            clearable={true}
            onChange={(val) => setEventKind(val)}
            mb="md"
            data={existingKinds}
          />
        )}

        {leadOrigins && (
          <Select
            variant="filled"
            value={leadOrigin}
            placeholder={'Aufmerksam geworden'}
            clearable={true}
            onChange={(val) => setLeadOrigin(val)}
            mb="md"
            data={leadOrigins}
          />
        )}
      </Box>
      <Space h="md" />
    </>
  );
};

const getYears = () => {
  const startYear = 2020;
  const endYear = new Date().getFullYear() + 2;

  return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
    const year = endYear - i; // descending order
    return { value: String(year), label: String(year) };
  });
};

export default StatisticsNavBar;
